import type { Sex } from './template';

export const SALUTATIONS = ['Mr', 'Mrs', 'Ms', 'Miss', 'Master', 'Baby', 'Baby of', 'Dr'] as const;
export type Salutation = (typeof SALUTATIONS)[number];

const IMPLIED_SEX: Partial<Record<Salutation, Sex>> = {
  Mr: 'M',
  Master: 'M',
  Mrs: 'F',
  Ms: 'F',
  Miss: 'F',
};

/**
 * Catches mismatches like "Mrs. MANZOOR · 45 Years | Male" seen on a real sample.
 * Returns a message when the salutation implies a different sex, otherwise null.
 */
export function salutationMismatch(
  salutation: Salutation | undefined,
  sex: Sex | undefined,
): string | null {
  if (!salutation || !sex) return null;
  const implied = IMPLIED_SEX[salutation];
  if (implied && implied !== sex) {
    return `"${salutation}." does not match sex ${sex === 'M' ? 'Male' : sex === 'F' ? 'Female' : 'Other'}`;
  }
  return null;
}

/** Indian mobile numbers normalised to E.164 (+91XXXXXXXXXX); null when not valid. */
export function normalizeIndianMobile(input: string): string | null {
  const digits = input.replace(/\D/g, '');
  const local =
    digits.length === 12 && digits.startsWith('91')
      ? digits.slice(2)
      : digits.length === 11 && digits.startsWith('0')
        ? digits.slice(1)
        : digits;
  return /^[6-9]\d{9}$/.test(local) ? `+91${local}` : null;
}

/** "+919876544417" → "••••••4417" for screens shown before an OTP. */
export function maskPhone(e164: string): string {
  return `••••••${e164.slice(-4)}`;
}
